import Router from "vue-router";

import home from "@/view/home.vue";
import login from "@/view/login.vue";
const routerPush = Router.prototype.push;
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch((err) => {});
};

let routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: "/",
    name: "/home",
    component: home
  },
];
let router = new Router({
  routes,
});

export default router;
